import _ from "lodash";

import React, { Component } from 'react';
import { Modal, Icon, Popconfirm, Tabs } from 'antd'

import AttachmentUpload from "./AttachmentUpload";

const { TabPane } = Tabs;

class ProofOfPayment extends Component {

	render() {
		const {
			isVisible,
			onClose,
			selectedOrder,
			activeKey,
			excluded,
			onSubmitCallback
		} = this.props

		const tabs = {
			upload: {
				title: "Attachment Upload",
				icon: "upload",
				component: <AttachmentUpload selectedOrder={selectedOrder} onSubmitCallback={onSubmitCallback}/>
			}
		}

		return (<Modal
			title={<span>Proof of Payment Attachment</span>}
			visible={isVisible}
			footer={null}
			maskClosable={true}
			closable={true}
			closeIcon={(<div>
				<Popconfirm
					title="Are you sure you want to proceed with the attachment?"
					onConfirm={onClose}
					okText="Confirm"
					cancelText="Cancel"
				>
					<Icon type="close" />
				</Popconfirm>
			</div>)}
		>
			<Tabs defaultActiveKey={activeKey || "list"}>
				{
					_.map(_.omit(tabs, excluded), (value, index) => {
						return (<TabPane
							tab={
								<span>
									<Icon type={value.icon} />
									{value.title}
								</span>
							}
							key={index}
						>
							{value.component}
						</TabPane>)
					})
				}
			</Tabs>
		</Modal>)
	}
}

export default ProofOfPayment
